import { request } from '../request';

const customerApi = {
  /**
   * 获取会员信息
   */
  getCustomerProfile(customerId: number) {
    return request<GetCustomerProfileResponse>({
      path: '/pad/customer/v1/getCustomerProfile',
      query: { customerId },
    });
  },
  /**
   * 查询会员
   */
  getCustomers(params: GetCustomersParams) {
    return request<GetCustomersResponse>({
      path: '/pad/customer/v2/getCustomers',
      query: params,
    });
  },
  /**
   * 获取所有的客户来源
   */
  getCustomerSources() {
    return request<GetCustomerSourcesResponse[]>({
      path: '/pad/customer/v1/getCustomerSources',
    });
  },
  /**
   * 新建会员
   */
  createCustomer(params: CreateCustomerParams) {
    return request<CreateCustomerResponse>({
      path: '/pad/customer/v1/createCustomer',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 编辑会员信息
   */
  updateCustomer(params: UpdateCustomerParams) {
    return request<CreateCustomerResponse>({
      path: '/pad/customer/v1/updateCustomer',
      method: 'POST',
      data: params,
    });
  },
  /**
   * 校验用户是否存在
   */
  checkCustomerExists(params: CheckCustomerExistsParams) {
    return request<boolean>({
      path: '/pad/customer/v1/checkCustomerExists',
      method: 'POST',
      query: params,
    });
  },
  /**
   * 发送验证码
   */
  sendSMSCode(phoneNumber: string) {
    return request({
      path: '/pad/customer/v1/sendSMSCode',
      method: 'POST',
      query: { phoneNumber },
    });
  },
  /**
   * 生成AI报告播报语音
   */
  getAIReportAudio(sessionId: string) {
    return request<string>({
      path: '/pad/customer/health/report/v1/audio/generate',
      query: { sessionId },
    });
  },
  /**
   * 获取会员信息
   */
  getBodyChange(customerId: number) {
    return request<GetBodyChangeResponse>({
      path: '/pad/customer/v1/body/change',
      query: { customerId },
    });
  },
};

export default customerApi;
